import { Component, Input, OnInit } from '@angular/core';
import { ColumnData, ColumnFieldComponent } from '../../Column';
import * as _ from 'lodash';
import { AppLocaleService } from 'src/app/shared/services/app-locale.service';
import { localizedName } from 'src/app/shared/i18n/localized-name';

@Component({
  selector: 'app-default-column',
  templateUrl: './default-column.component.html',
  styleUrls: ['./default-column.component.scss']
})
export class DefaultColumnComponent implements ColumnFieldComponent, OnInit {

  @Input()
  data!: ColumnData;

  // `protected`, not `private`: DefaultImageColumnComponent needs the active language to name
  // the product in its `alt` text (see resolveAltText there).
  constructor(protected localeService: AppLocaleService) { }
  ngOnInit() { }

  getValue() {
    const row = this.data.row;
    const field = this.data.field.field;
    const lang = this.localeService.current;
    let value: any = _.result(row, field, '');
    if (value && value.id != null) {
      value = value.defaultDescription || localizedName(value, lang) || value.description || value.code || value.id;
    } else if (field && field.endsWith('.name')) {
      const parent: any = _.result(row, field.slice(0, -'.name'.length));
      const loc = localizedName(parent, lang);
      if (loc) {
        value = loc;
      }
    }
    return value;
  }

  getTooltip() {
    return this.data.field.tooltip ? this.data.field.tooltip(this.data) : '';
  }

  getMatIcon() {
    return this.data.field.matIcon ? this.data.field.matIcon(this.data) : '';
  }

}
